@if (manageableResources$ | async) {
  <ng-content></ng-content>
}
@if (preferredLanguage$ | async) {
  <ng-container></ng-container>
}
@if (Status === ENTITLEMENT_STATUS.ACTIVE) {
  <div class="deallocate-btn-container">
    <span class="status-icon">
      <i class="ra-icon-ide-md-color-check"></i>
      <span>Active</span>
    </span>

    @if ((showDeallocateBtn$ | async) === true) {
      <ra-ui-text-button label="Deallocate" (click)="btnClickedHandler()"></ra-ui-text-button>
    }
  </div>
}
@if (Status === ENTITLEMENT_STATUS.PENDING) {
  <div class="deallocate-btn-container">
    <span class="status-icon" [raUiTooltip]="pendingEntitlementTooltip" [tooltipConfig]="tooltipConfig">
      <i class="ra-icon-ide-md-auto-refresh"></i>
      <span>Pending</span>
    </span>
    @if ((showDeallocateBtn$ | async) === true) {
      <ra-ui-text-button label="Deallocate" (click)="btnClickedHandler()"></ra-ui-text-button>
    }
  </div>
}
@if (Status === ENTITLEMENT_STATUS.COMPLETED) {
  <div class="status-icon">
    <i class="ra-icon-ide-md-color-unprovisioned cancelled-icon"></i>
    <span class="grey-out">Expired</span>
  </div>
}

@if (Status === ENTITLEMENT_STATUS.CANCELLED) {
  <div class="cancelled-status">
    <span
      class="status-icon"
      [raUiTooltip]="'This entitlement has been cancelled by an administrator.'"
      [tooltipConfig]="tooltipConfig"
    >
      <i class="ra-icon-ide-md-color-unprovisioned cancelled-icon"></i>
      <span class="grey-out">Cancelled</span>
    </span>
  </div>
}
